import { useRef } from "react";
import { useImmer } from "use-immer";

interface WorkflowState {
  showRating: boolean;
  restartFromFirstNode: boolean;
}

export const useUiActionsChatState = () => {
  const panelRef = useRef<HTMLDivElement | null>(null);

  const [workflowState, setWorkflowState] = useImmer<WorkflowState>({
    showRating: false,
    restartFromFirstNode: true,
  });

  const setShowRating = (value: boolean) => {
    setWorkflowState((draft) => {
      draft.showRating = value;
    });
  };

  const setRestartFromFirstNode = (value: boolean) => {
    setWorkflowState((draft) => {
      draft.restartFromFirstNode = value;
    });
  };

  return {
    panelRef,
    workflowState,
    setShowRating,
    setRestartFromFirstNode,
  };
};
